<template>
	<div class="toast">
		<div
			v-for="(message, index) in messages"
			:key="`toast-${index}`"
			class="message"
			:class="{ [message.type]: true }"
			@click="handleDismiss(index)"
		>
			<span class="close-btn">
				<Icon
					icon-name="e-remove"
					size="lg"
				/>
			</span>
			<div class="message-content">
				<template v-if="message.text">
					{{ message.text }}
				</template>
				<component
					:is="message.component"
					v-else
				/>
			</div>
		</div>
	</div>
</template>

<script>
import { EVENT, bus } from '@videotools/js/events';
import { mapGetters } from 'vuex';

const TYPE = {
	ERROR:   'error',
	SUCCESS: 'success',
};

export default {
	name: 'Toast',
	data() {
		return {
			messages: [],
		};
	},
	computed: {
		...mapGetters({
			isMobileWebApp: 'app/isMobileWebApp',
		}),
	},
	mounted() {
		bus.subscribe(EVENT.ERROR, this.handleError);
		bus.subscribe(EVENT.SUCCESS, this.handleSuccess);
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.setRight);
	},
	destroyed() {
		bus.unsubscribe(EVENT.ERROR, this.handleError);
		bus.unsubscribe(EVENT.SUCCESS, this.handleSuccess);
	},
	methods: {
		handleError(error) {
			// TODO: generate id, use for key and for removing the error after timeout
			// TODO: error should be an instance of ApiError instead of the plain response's error
			const responseData = error?.response?.data;
			if (responseData?.errors) {
				const errors = responseData.errors;
				// if it happens to be a string instead of an object
				if (typeof errors === 'string') {
					this.messages.push({
						type: TYPE.ERROR,
						text: errors,
					});
					return;
				}
				for (const [, v] of Object.entries(errors)) {
					for (const err of v) {
						this.messages.push({
							type: TYPE.ERROR,
							text: err,
						});
					}
				}
			} else if (responseData?.error) {
				this.messages.push({
					type: TYPE.ERROR,
					text: responseData.error,
				});
			} else {
				const message = { type: TYPE.ERROR };

				if (typeof error === 'string') {
					message.text = error || 'Unknown error.';
				} else if (error?.message) {
					message.text = error.message;
				} else {
					message.component = error;
				}

				this.messages.push(message);
			}
		},
		handleSuccess(message) {
			const msg = { type: TYPE.SUCCESS };

			if (typeof message === 'string') {
				msg.text = message;
			} else {
				msg.component = message;
			}

			this.messages.push(msg);
		},
		handleDismiss(index) {
			this.messages.splice(index, 1);
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@videotools/sass/_fonts';
@import '@shared/sass/shared-variables';

.toast {
	@include z-index('toast', 'tagging-tool');
	position: absolute;
	top: 0;
	right: 0;
	width: 432px;
	height: auto;

	.mobile & {
		z-index: 99999;
		width: auto;
		top: 16px;
		left: 16px;
		right: 16px;

		.close-btn {
			right: 24px;
		}

		.message-content {
			padding: 24px 48px 24px 24px;
		}
	}
}

.message {
	cursor: pointer;
	position: relative;
	border-radius: 2px;
	margin-bottom: 15px;

	.message-content {
		max-width: 370px;
		padding: 24px;
		color: inherit;
		@include text-md-2;
	}

	.close-btn {
		position: absolute;
		top: 24px;
		margin-left: 28px;
		right: 28px;
	}

	&.error {
		background: var(--color-red);

		.aicon {
			color: var(--color-white);
		}
	}

	&.success {
		background: var(--color-success);
		color: var(--color-black);

		.aicon {
			color: var(--color-black);
		}
	}
}
</style>
